<template>
  <!--v-tooltip
    
    right
    open-on-hover
    min-width=250
    color=white
    open-delay=1000>
      <template-- v-slot:activator="{ on, attrs }">
        <v-btn class="gifBtn" icon dark v-bind="attrs" v-on="on">
          <v-icon size="18" color="grey lighten-2">mdi-help-circle</v-icon>
        </v-btn>
      </template-->
  <v-flex layout justify-center>
    <v-img
      :class="[gameGif === 'fake.gif' ? 'fakeGifimg' : 'gifimg elevation-2']"
      v-if="gameGif"
      :src="pathGif + gameGif"
      :contain="true"
    >
    </v-img>
  </v-flex>
  <!--/v-tooltip-->
</template>

<script>
export default {
  name: 'Gif',
  props: {
    gameGif: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      pathGif: '/images/gifs/',
      isActive: false,
    };
  },
  created() {},
  methods: {},
  watch: {},
};
</script>

<style lang="sass">
@import '../assets/_vars.scss'
.indiceClass
  top: 30px
  left: 30px
.v-tooltip__content.menuable__content__active
  opacity: 1!important;
.gifimg
  border: 1px solid $secondary
  border-radius: 4px
  max-height: 300px
  max-width: 200px
.fakeGifimg
  max-height: 300px
  max-width: 200px
</style>
